import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=10683ffe&scoped=true&"
import script from "./jump.vue?vue&type=script&lang=js&"
export * from "./jump.vue?vue&type=script&lang=js&"
import style0 from "./jump.vue?vue&type=style&index=0&id=10683ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10683ffe",
  null
  
)

export default component.exports